/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 24/11/2021
 */

export const InviteStatus = Object.freeze({
	NOT_SET: "NOT_SET",
	INVITE_PENDING: "INVITE_PENDING",
	INVITE_ACCEPTED: "INVITE_ACCEPTED",
})
